import { makeObservable, observable, action } from "mobx";

class BaseTagStore {
  baseTag = "";

  constructor() {
    makeObservable(this, {
      baseTag: observable,
      updateBaseTag: action
    });
  }

  updateBaseTag = newTag => {
    this.baseTag = newTag;
  };
}

const store = new BaseTagStore();
export default store;
export { BaseTagStore };
